if (!customElements.get('amelia-video-banner')) {
  class AmeliaVideoBanner extends HTMLElement {
    connectedCallback() {
      const isMobile = window.innerWidth <= 749;
      const mobileVid  = this.querySelector('[class*="video-mobile"]');
      const desktopVid = this.querySelector('[class*="video-desktop"]');

      if (mobileVid || desktopVid) {
        // Block with separate desktop / mobile videos
        this.video = (isMobile && mobileVid) ? mobileVid : (desktopVid || mobileVid);
      } else {
        // Simple block: single video element
        this.video = this.querySelector('[class*="video-banner-video"]') || this.querySelector('video');
        if (this.video) {
          this.video.addEventListener('loadedmetadata', () => {
            this.video.play().catch(() => {});
          });
          return;
        }
      }

      if (!this.video) return;

      this.playPauseBtn = this.querySelector('button[class*="play-pause"]');
      this.muteBtn      = this.querySelector('button[class*="-mute"]');
      this.playIcon     = this.querySelector('[class*="play-icon"]');
      this.pauseIcon    = this.querySelector('[class*="pause-icon"]');
      this.soundIcon    = this.querySelector('[class*="sound-icon"]');
      this.muteIcon     = this.querySelector('[class*="mute-icon"]');

      this._setupControls();
      this._updatePlay();
      this._updateMute();
    }

    _setupControls() {
      if (this.playPauseBtn) {
        this.playPauseBtn.addEventListener('click', () => {
          this.video.paused ? this.video.play() : this.video.pause();
          this._updatePlay();
        });
      }
      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', () => {
          this.video.muted = !this.video.muted;
          this._updateMute();
        });
      }
      this.video.addEventListener('play',  () => this._updatePlay());
      this.video.addEventListener('pause', () => this._updatePlay());
    }

    _updatePlay() {
      if (!this.playIcon || !this.pauseIcon) return;
      const paused = this.video.paused;
      this.playIcon.style.display  = paused ? 'block' : 'none';
      this.pauseIcon.style.display = paused ? 'none'  : 'block';
    }

    _updateMute() {
      if (!this.soundIcon || !this.muteIcon) return;
      const muted = this.video.muted;
      this.soundIcon.style.display = muted ? 'none'  : 'block';
      this.muteIcon.style.display  = muted ? 'block' : 'none';
    }
  }

  customElements.define('amelia-video-banner', AmeliaVideoBanner);
}
